import { useState, useEffect } from 'react';
import { versionService } from '../services/versionService';
import { toastService } from '../services/toastService';

export const useVersionCheck = () => {
  const [versionState, setVersionState] = useState({
    isChecking: true,
    needsUpdate: false,
    isFirstInstall: false,
    versionInfo: null,
    showUpdatePrompt: false
  });

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const result = await versionService.handleVersionUpdate();
        const versionInfo = versionService.getVersionInfo();

        setVersionState({
          isChecking: false,
          needsUpdate: result.needsUpdate,
          isFirstInstall: result.isFirstInstall,
          versionInfo,
          showUpdatePrompt: result.needsUpdate && !result.clearFailed
        });

        if (result.needsUpdate) {
          if (result.clearFailed) {
            toastService.warning('App updated but cache clear failed. Please refresh manually if you face issues.');
          } else {
            toastService.success(`App updated to v${result.newVersion}! Cache cleared automatically.`);
          }
        }

      } catch (error) {
        console.error('Version check failed:', error);
        setVersionState(prev => ({
          ...prev,
          isChecking: false
        }));
      }
    };

    checkVersion();
  }, []);

  const dismissUpdatePrompt = () => {
    setVersionState(prev => ({
      ...prev,
      showUpdatePrompt: false
    }));
  };

  const forceRefresh = () => {
    window.location.reload();
  };

  return {
    ...versionState,
    dismissUpdatePrompt,
    forceRefresh
  };
};